import Vue from "vue"
import EventBus from './EventBus.js'
import App from "./App.vue"
import Documents from "./components/Documents.vue"
import SignersMonitor from "./components/SignersMonitor.vue"
import StatusEnvelope from './shared/statusEnvelope.js';

//Plugins//
import VueResource from "vue-resource"
import VueI18n from 'vue-i18n'

Vue.use(VueResource)
Vue.use(VueI18n);

Vue.config.productionTip = false

let messages = require('./localization/languages.json')

const i18n = new VueI18n({
    locale: navigator.language,
    messages
});

new Vue({
    i18n,
    render: h => h(App)
}).$mount('#app');

EventBus.$on('update-envelope-view', (
    el,
    zeevUrl,
    token,
    instanceId,
    taskId,
    signPlatformUid,
    userExecuteId,
    userExecuteOriginalId,
    envelopeUid,
    apiUrl,
    envelopeStatusId,
    language,
    assignmentId
) => {
    window.zeevSign.renderComponent(
        el,
        zeevUrl,
        token,
        instanceId,
        taskId,
        signPlatformUid,
        userExecuteId,
        userExecuteOriginalId,
        envelopeUid,
        apiUrl,
        envelopeStatusId,
        language,
        assignmentId);
});

window.zeevSign = {}
window.zeevSign.renderComponent = (
    el,
    zeevUrl,
    token,
    instanceId,
    taskId,
    signPlatformUid,
    userExecuteId,
    userExecuteOriginalId,
    envelopeUid,
    apiUrl,
    envelopeStatusId,
    language,
    assignmentId
) => {

    let module = ""
    let envelopeSent = (envelopeStatusId && envelopeStatusId != StatusEnvelope.Created);

    if (envelopeSent)
        module = SignersMonitor
    else
        module = Documents

    new Vue({
        i18n,
        el: el,
        render: (h) =>
            h(module, {
                props: {
                    el,
                    zeevUrl,
                    token,
                    instanceId,
                    taskId,
                    signPlatformUid,
                    userExecuteId,
                    userExecuteOriginalId,
                    envelopeUid,
                    apiUrl,
                    envelopeStatusId,
                    language,
                    assignmentId
                },
            }),
    });

    if (!envelopeSent && !envelopeUid)
        window.zeevSign.createObserverAttachments();
}

window.zeevSign.createObserverAttachments = () => {
    var targetNode = document.querySelector('#tblFile > tbody');
    var config = { attributes: false, childList: true };

    var callback = function (mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.type == 'childList') {
                EventBus.$emit('update-documents-list');
            }
        }
    };

    var observer = new MutationObserver(callback);

    observer.observe(targetNode, config);
}
